var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgServing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 4C9 2.34314 10.3432 1 12 1C13.6568 1 15 2.34314 15 4V4.54455C18.214 5.75717 20.5 8.86162 20.5 12.5V17H21C21.5523 17 22 17.4477 22 18C22 18.5523 21.5523 19 21 19H3C2.44772 19 2 18.5523 2 18C2 17.4477 2.44772 17 3 17H3.5V12.5C3.5 8.86162 5.78597 5.75717 9 4.54455V4ZM11 4.0582C11.328 4.01976 11.6617 4 12 4C12.3383 4 12.672 4.01976 13 4.0582V4C13 3.44772 12.5523 3 12 3C11.4477 3 11 3.44772 11 4V4.0582ZM5.5 17H18.5V12.5C18.5 8.91013 15.5899 6 12 6C8.41013 6 5.5 8.91013 5.5 12.5V17ZM8.5 11.5C9.05228 11.5 9.5 11.9477 9.5 12.5V14.5C9.5 15.0523 9.05228 15.5 8.5 15.5C7.94772 15.5 7.5 15.0523 7.5 14.5V12.5C7.5 11.9477 7.94772 11.5 8.5 11.5ZM2 21C2 20.4477 2.44772 20 3 20H21C21.5523 20 22 20.4477 22 21C22 21.5523 21.5523 22 21 22H3C2.44772 22 2 21.5523 2 21Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServing);
export default __webpack_public_path__ + "static/media/serving.ce22d6ee5d8032d58c92a18eab816813.svg";
export { ForwardRef as ReactComponent };